/**
 * MescreenAdmin.tsx — Admin → Marketplace → mescreen.
 * Thin wrapper over the reusable LabIntegrationAdmin.
 */
import { LabIntegrationAdmin } from '@/pages/admin/LabIntegrationAdmin';

export function MescreenAdmin() {
  return (
    <LabIntegrationAdmin
      integrationKey="mescreen"
      title="mescreen"
      subtitle="At-home mitochondrial-health test kit, shipped to the patient, from Versea Health"
      vendorName="mescreen"
    />
  );
}
